(function () {
    'use strict';

    angular
        .module('assets.mybimiboo.com')
        .controller('OrganizationsCtrl', OrganizationsCtrl);

    function OrganizationsCtrl($scope, $state, $stateParams, $location, $http, AuthenticationService, _env) {

        function getOrganizations(callback) {
            $http.get(_env.apiUrl + '/organizations').then(function (response) {
                $scope.organizations = response.data;
                _.forEach($scope.organizations, function (organization) {
                   organization.categories = [];
                    if(organization.has_equipment) organization.categories.push('fixed-assets');
                    if(organization.has_software) organization.categories.push('software');
                    if(organization.has_trademarks) organization.categories.push('intellectual property');
                    if(organization.has_library) organization.categories.push('library');
                });
                if(callback) callback();
            });
        }

        getOrganizations();

        $scope.edit = function(organization) {
            if (organization) {
                $scope.organization = angular.copy(organization);
            } else {
                $scope.organization = {};
            }

            $('#modal-default').modal('show');
        }

        $scope.save = function () {
            if (!$scope.organization) return;

            if (!$scope.organization.name) {
                error('Name is required');
                return;
            }

            var data = {
                name: $scope.organization.name,
                has_equipment: $scope.organization.has_equipment,
                has_inventory: $scope.organization.has_inventory,
                has_software: $scope.organization.has_software,
                has_trademarks: $scope.organization.has_trademarks,
                has_library: $scope.organization.has_library,
            };

            $scope.proccessing = true;

            if ($scope.organization.id) {
                $http.put(_env.apiUrl + '/organizations/' + $scope.organization.id, data).then(function(response) {
                    $('#modal-default').modal('hide');
                    getOrganizations();
                }, function (reason) {
                    Swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: JSON.stringify(reason.data, null, 2)
                    });
                });
            } else {
                $http.post(_env.apiUrl + '/organizations', data).then(function(response) {
                    $('#modal-default').modal('hide');
                    getOrganizations();
                }, function (reason) {
                    Swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: JSON.stringify(reason.data, null, 2)
                    });
                });
            }
        }

        $scope.delete = function () {
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then(function (result) {
                if (result.value) {
                    $scope.proccessing = true;
                    $('#modal-default').modal('hide');
                    $http.delete(_env.apiUrl + '/organizations/' + $scope.organization.id).then(function () {
                        getOrganizations();
                        Swal.fire({
                            type: 'success',
                            title: 'Organization successfully deleted',
                            position: 'top-end',
                            timer: 1000
                        });
                    }, function (reason) {
                        Swal.fire({
                            type: 'error',
                            title: 'Oops...',
                            text: JSON.stringify(reason.data, null, 2)
                        });
                    });
                }
            });
        }
    }
})();